function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.472 48h21.467m12.57 0H55V36.031L39 19H0v29h3.094m26.937-25H37.9l11.194 11.938V36H30.03z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.898 40.108a6.187 6.187 0 11-12.375 0 6.187 6.187 0 0112.375 0z",
  transform: "matrix(1.03035 0 0 1.03035 -5.832 8.05)",
  strokeWidth: 0.971,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.382 49.375a3.057 3.057 0 11-6.114 0 3.057 3.057 0 016.114 0z",
  strokeWidth: 0.9998964800000001,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.03035 0 0 1.03035 28.168 8.05)",
  d: "M20.898 40.108a6.187 6.187 0 11-12.375 0 6.187 6.187 0 0112.375 0z",
  strokeWidth: 0.971,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.382 49.375a3.057 3.057 0 11-6.114 0 3.057 3.057 0 016.114 0z",
  strokeWidth: 0.9998964800000001,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 30.5a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z",
  strokeWidth: 1.00057496
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 25.5V28H9.5v5H12v2.5h5V33h2.5v-5H17v-2.5h-5zM26 12a3 3 0 00-3 3v4h6v-4a3 3 0 00-3-3z"
}));

var SvgAmbulance = function SvgAmbulance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAmbulance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Ambulance.6470341d.svg";
export { ForwardRef as ReactComponent };